<script lang="ts" setup>
	import StringMethods from '~/utils/character'

	defineProps<{
		title: string
	}>()
	const { coverPeriod } = storeToRefs(useProductsStore())
	const { navigateToProduct } = useProductsStore()
	const { toLower } = StringMethods()
	const { StringToNumber, internationalNoFormat } = useCurrency()
	const { allProduct } = useProductLogic('business')
	const comprehensivePlan = computed(() => {
		return allProduct.value.find(item => item.code_name === ProductCode.COMPREHENSIVE_AUTO) ?? null
	})
	const selectedTab = shallowRef('monthly')
	const calculatedValue = shallowRef(0)
	const vehicleValue = shallowRef(0)
	const productPrice = computed(() => {
		let price =
			comprehensivePlan.value?.prices.find(item => toLower(item.cover_period) === toLower(selectedTab.value))
				?.market_price ?? 0
		price = parseFloat(String(price)) ?? 0
		return price
	})

	const calculateVehicleValue = (val = vehicleValue.value) => {
		if (StringToNumber(val ?? 0) >= 1000000) {
			const price = (productPrice.value * StringToNumber(val ?? 0)) / 100
			calculatedValue.value = price
		} else {
			calculatedValue.value = 0
		}
	}
	watch(productPrice, () => {
		calculateVehicleValue()
	})
	watch(vehicleValue, v => {
		calculateVehicleValue(v)
	})
</script>

<template>
	<div class="flex flex-col w-full justify-center items-center">
		<ui-title-header
			:title="title"
			:ui="{ size: 'md:text-[3.25em] text-[2em]', lineHeight: 'md:leading-[62.4px] leading-[38.4px]' }"
		/>

		<div
			data-allow-mismatch
			class="bg-auto-500 sm:min-h-[902px] w-full mt-16 flex py-5 md:py-10 flex-col justify-around items-center"
		>
			<div class="px-3 md:px-0">
				<client-only>
					<ui-tab-group
						:list="coverPeriod"
						v-model:value="selectedTab"
						:ui="{
							tabProps: {
								wrapper: 'flex-none max-w-[500px] mx-auto mb-10',
								list: {
									base: 'w-full  tracking-wider rounded-[48px] border-[0.875px]  border-auto-500 ',
									height: '',
									rounded: 'rounded-[20px]',
									marker: {
										base: 'min-h-[40px]',
										rounded: 'rounded-[20px]',
										background: 'bg-auto-500'
									},
									tab: {
										height: 'min-h-[40px]',
										active: 'text-white font-semibold',
										font: 'font-medium capitalize ',
										shadow: ''
									}
								}
							}
						}"
					/>
				</client-only>
			</div>

			<div class="w-full px-5">
				<div
					class="max-w-[400px] sm:max-w-[606px] w-full md:min-h-[610px] rounded-lg sm:p-8 p-5 border border-auto-500 bg-[#FFF7F0] mx-auto"
				>
					<!-- <div class="text-auto-600 mb-3 md:text-xl font-semibold text-base leading-[24px] md:leading-normal">
						Calculate Your Vehicle Premium
					</div> -->

					<p>
						<span class="text-blue-950 sm:text-[3.25em] text-[2em] font-bold md:eading-[64px]">
							From {{ productPrice }}%
						</span>
						<span class="text-gray-600 sm:text-xl text-sm font-medium md:leading-7"> / vehicle value </span>
					</p>

					<div class="sm:mt-10 mt-5">
						<p class="text-blue-950 md:text-xl text-base font-bold md:leading-7">
							Enter your vehicle value to see your premium
						</p>

						<div class="pb-10 border-b mb-5">
							<div class="inline-flex mt-5 overflow-hidden item-center relative">
								<span
									class="text-gray-600 md:text-[3.25em] font-medium md:leading-[64px] absolute top-0 bottom-0 my-auto h-full flexed flex-col justify-center sm:px-10 px-5 text-[1.75em] pointer-events-none"
								>
									₦
								</span>
								<client-only>
									<input
										placeholder="0.00"
										v-model="vehicleValue"
										type="text"
										:min="0"
										v-format="true"
										class="sm:py-[18px] font-medium py-[13px] pl-12 rounded-[12px] w-full border tracking-normal sm:pl-24 sm:text-[3em] text-[1.75em] placeholder:text-gray-300 bg-white outline-auto-500"
									/>
								</client-only>
							</div>
						</div>
						<p class="text-blue-950 md:text-xl text-base font-bold md:leading-7">Your Plan Premium</p>
						<div
							class="sm:py-[18px] py-[13px] mt-3 sm:px-12 px-6 rounded-[12px] w-full tracking-normal sm:text-[3em] text-[1.75em] bg-auto-100 text-auto-900 font-[700] flex items-center justify-between flex-wrap"
						>
							₦ {{ internationalNoFormat(calculatedValue) ?? '0.00' }}
							<ui-pill
								:label="`paid ${selectedTab}`"
								:ui="{ base: 'border border-base-200 text-main bg-base-50 capitalize' }"
							/>
						</div>
					</div>
				</div>
			</div>
			<div>
				<ui-btn
					:ui="{
						btn: {
							base: 'bg-white mt-8 min-h-[56px]',
							onHoverPseudo: 'hover:before:bg-auto-800'
						},
						text: {
							base: 'text-auto-500  group-hover:text-white'
						}
					}"
					@click="navigateToProduct(ProductCode.COMPREHENSIVE_AUTO)"
				>
					<template #icon>
						<tools-icon dir="random" icon="car-wheel" width="20" height="20" />
					</template>
					<span>Get Covered Now</span>
				</ui-btn>
			</div>
		</div>
	</div>
</template>

<style></style>
